import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "results", "clearBtn"]
  static values = { url: String }

  connect() {
    this.clickOutsideHandler = this.clickOutside.bind(this)
    document.addEventListener("click", this.clickOutsideHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler)
  }

  search() {
    if (this.hasClearBtnTarget) {
      if (this.inputTarget.value.length > 0) {
        this.clearBtnTarget.classList.remove("hidden")
      } else {
        this.clearBtnTarget.classList.add("hidden")
      }
    }

    // Clear the hidden selected ID when the user starts typing
    if (this.hiddenTarget.value !== '') {
      this.hiddenTarget.value = ''
      this.hiddenTarget.dispatchEvent(new Event('change', { bubbles: true }))
      this.filter()
    }

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.performSearch()
    }, 300)
  }

  async performSearch() {
    const query = this.inputTarget.value.trim()
    const url = new URL(this.urlValue, window.location.origin)

    // If text is cleared, ensure we hide results unless it's the checked_in specific list
    if (query.length < 1 && !url.searchParams.has('status')) {
      this.hideResults()
      return
    }

    try {
      url.searchParams.set('query', query)
      const response = await fetch(url.toString())
      const players = await response.json()
      this.renderResults(players)
    } catch (error) {
      console.error("Error searching players:", error)
    }
  }

  renderResults(players) {
    if (players.length === 0) {
      this.resultsTarget.innerHTML = `
        <div class="px-3 py-2 text-sm text-gray-500">
          Ничего не найдено
        </div>
      `
    } else {
      this.resultsTarget.innerHTML = players.map(player => `
        <div 
          class="px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
          data-action="click->autocomplete#select"
          data-id="${player.id}"
          data-name="${player.full_name}"
        >
          ${player.full_name}
          ${player.card_number ? `<span class="text-xs text-gray-400 ml-2">#${player.card_number}</span>` : ''}
        </div>
      `).join("")
    }

    this.showResults()
  }

  select(event) {
    const { id, name } = event.currentTarget.dataset
    this.hiddenTarget.value = id
    this.inputTarget.value = name
    this.hideResults()
    
    if (this.hasClearBtnTarget) this.clearBtnTarget.classList.remove("hidden")
    
    // Dispatch change event on hidden target so listeners can react
    this.hiddenTarget.dispatchEvent(new Event('change', { bubbles: true }))
    this.filter()
  }

  clear() {
    this.inputTarget.value = ''
    this.hiddenTarget.value = ''
    this.hideResults()
    if (this.hasClearBtnTarget) this.clearBtnTarget.classList.add("hidden")
    this.hiddenTarget.dispatchEvent(new Event('change', { bubbles: true }))
    this.filter()
  }

  showResults() {
    this.resultsTarget.classList.remove("hidden")
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden")
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }

  filter() {
    var filterEl = document.getElementById('shift-log-filter');
    var searchEl = document.getElementById('shift-log-search-hidden');
    
    if (!filterEl || !searchEl) {
      console.error("filter: Missing DOM elements! filterEl:", !!filterEl, "searchEl:", !!searchEl);
      return;
    }
    
    var category = filterEl.value;
    var selectedPlayerId = searchEl.value;
    var rows = document.querySelectorAll('.shift-log-row');
    var visible = 0;
    
    console.log("Stimulus filter running! category:", category, "selectedPlayerId:", selectedPlayerId, "rows:", rows.length);

    rows.forEach(function(row) {
      // Category match
      var rowCategory = row.dataset.logCategory;
      var matchesCategory = (category === 'all') || 
                            (category === rowCategory) ||
                            (category === 'manager' && rowCategory === 'bar');

      // Search match
      var rowPlayerId = row.dataset.playerId;
      var matchesSearch = true;
      if (selectedPlayerId) {
        matchesSearch = String(rowPlayerId) === String(selectedPlayerId);
      }

      if (matchesCategory && matchesSearch) {
        row.style.display = '';
        visible++;
      } else {
        row.style.display = 'none';
      }
    });

    const countEl = document.getElementById('shift-log-count');
    if (countEl) countEl.textContent = visible + ' / ' + rows.length;
  }
}
